import {
  CREATE_USER_COMPONENT_GROUP,
  UPDATE_USER_COMPONENT_GROUP,
  SET_USER_COMPONENT_GROUPS,
  SET_COMPONENT_GROUP_COMPONENTS,
  SET_ACTIVE_USER_COMPONENT_GROUPS,
  FETCH_USER_COMPONENT_GROUPS,
  FETCH_COMPONENT_GROUP_COMPONENTS,
  FETCH_ACTIVE_USER_COMPONENT_GROUPS,
  ADD_USER_COMPONENT_GROUP,
  UPDATE_USER_COMPONENT_GROUPS_STATE,
  SET_DELETE_USER_COMPONENT_GROUP_SUCCESS_RESET,
  DELETE_USER_COMPONENT_GROUP,
  FETCH_TOOLBOX_DATA
} from "redux/constants/flowDesigner";

export const createUserComponentGroup = (tenant_id, input) => ({
  type: CREATE_USER_COMPONENT_GROUP,
  payload: { tenant_id, input }
});
export const updateUserComponentGroup = (tenant_id, group_id, input, type) => ({
  type: UPDATE_USER_COMPONENT_GROUP,
  payload: { tenant_id, group_id, input, type }
});
export const setUserComponentGroups = (payload) => ({
  type: SET_USER_COMPONENT_GROUPS,
  payload
});
export const setComponentGroupComponents = (payload) => ({
  type: SET_COMPONENT_GROUP_COMPONENTS,
  payload
});
export const setActiveUserComponentGroups = (payload) => ({
  type: SET_ACTIVE_USER_COMPONENT_GROUPS,
  payload
});
export const fetchUserComponentGroups = (tenant_id) => ({
  type: FETCH_USER_COMPONENT_GROUPS,
  payload: { tenant_id }
});
export const fetchActiveUserComponentGroups = (tenant_id) => ({
  type: FETCH_ACTIVE_USER_COMPONENT_GROUPS,
  payload: { tenant_id }
});
export const fetchComponentGroupComponents = (tenant_id) => ({
  type: FETCH_COMPONENT_GROUP_COMPONENTS,
  payload: { tenant_id }
});
export const addUserComponentGroup = (payload) => ({
  type: ADD_USER_COMPONENT_GROUP,
  payload
});
export const deleteUserComponentGroup = (tenant_id, group_id) => ({
  type: DELETE_USER_COMPONENT_GROUP,
  payload: { tenant_id, group_id }
});
export const updateUserComponentGroupsState = (tenant_id) => ({
  type: UPDATE_USER_COMPONENT_GROUPS_STATE,
  payload: { tenant_id }
});
export const setDeleteUserComponentGroupSuccessReset = () => ({
  type: SET_DELETE_USER_COMPONENT_GROUP_SUCCESS_RESET
});
export const fetchToolboxData = (tenant_id) => ({
  type: FETCH_TOOLBOX_DATA,
  payload: { tenant_id }
});
